import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { AcquaintanceTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/AcquaintanceTypeCodesEnum';
import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { getActTypeActBlockId } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmOrganizationTemplateSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCatalogsKnmActTypesSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IKnmActTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmActTypeSelectOption';
import { IRequirementsNpaInitValues } from 'KnmPackage/RequirementsNpaModalModule/components/RequirementsNpaModal';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';

import {
  getKnmDataCreated,
  getKnmFormRef,
  getKnmIsErknmStatusDecisionAppealed,
  getKnmIsErknmStatusTypeCompleted,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IDictionarySelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IParticipantPosition } from '../../../APIPackage/DictionariesModule/interfaces/IParticipantPosition';
import { IKnmErknmForm } from '../../MainModule/interfaces/IKnmErknmForm';
import {
  getKnmErknmInitialFormValues,
  getKnmErknmIsPrescriptionOldRules,
} from '../../MainModule/selectors/knmErknmSelectors';
import { ErknmActHistory } from './ErknmActHistory';
import { ErknmActsItemContentImpossible } from './ErknmActsItemContentComponents/ErknmActsItemContentImpossible';
import { ErknmActsItemContentKnm } from './ErknmActsItemContentComponents/ErknmActsItemContentKnm';
import { ActTypesEnum } from '../enums';
import { ErknmPaperlessActContentKnm } from './ErknmPaperlessActComponents/ErknmPaperlessActContentKnm';
import { KnmLateFieldsRemark } from '../../../KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';
import { checkHasErrorInCollapseBlock } from '../../../functions/checkHasErrorInCollapseBlock';
import { IKnmErknmFormEvent } from '../../MainModule/interfaces/IKnmErknmFormEvent';

const COLLAPSE_TITLE_BASE = 'Акт';

interface IErknmActsItemProps {
  acts: IKnmErknmFormAct[] | undefined;
  addRequirementsNpa: (actFieldName: string, fieldName: string) => void;
  addViolatedMandatory: (initialValue: IRequirementsNpaInitValues, fieldName: string, parentFieldName?: string) => void;
  disableActAddingByImpossibleStatus: boolean;
  events: IKnmErknmFormEvent[] | undefined;
  expertsErknm: IKnmErknmFormExpert[] | undefined;
  id: string;
  index: number;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  isClosedByManyActs: boolean;
  isDecision?: boolean;
  isDisabledByDirty: boolean;
  isPaperless: boolean;
  isPm?: boolean;
  isWatchOnly: boolean;
  kindKnmCode: KnmKindCodesEnum | undefined;
  name: string;
  onRemove: () => void;
  organizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  participantPositionsSelectOptions: IDictionarySelectOption<IParticipantPosition>[] | undefined;
  value: IKnmErknmFormAct;
}

interface IErknmActsItemStoreProps {
  created: string | null | undefined;
  settings: IAdminSetting[] | undefined;
  formRef: IKnmFormRef | undefined;
  initialFormValues: IKnmErknmForm;
  isKnmStatusCompleted: boolean;
  isKnmStatusDecisionAppealed: boolean;
  knmActTypesOptions: IKnmActTypeSelectOption[] | undefined;
  isPrescriptionCheckByOldRules: boolean | undefined;
}

const ErknmActsItemWithoutStore = ({
  acts,
  addRequirementsNpa,
  addViolatedMandatory,
  disableActAddingByImpossibleStatus,
  events,
  expertsErknm,
  id,
  index,
  inspectorsErknm,
  isClosedByManyActs,
  isDecision,
  isDisabledByDirty,
  isPaperless,
  isPm,
  isWatchOnly,
  kindKnmCode,
  name,
  onRemove,
  organizationsTemplatesSelectOptions,
  participantPositionsSelectOptions,
  value,
  created,
  formRef,
  initialFormValues,
  isKnmStatusCompleted,
  isKnmStatusDecisionAppealed,
  knmActTypesOptions,
  settings,
  isPrescriptionCheckByOldRules,
}: IErknmActsItemProps & IErknmActsItemStoreProps) => {
  const { isNew: isNewAct } = value;
  const [isActCancelled, setIsActCancelled] = useState<boolean>(false);
  const [knmActType, setKnmActTypeSelected] = useState<number | null>(null);

  const [isKnmCollapseOpened, setIsKnmCollapseOpened] = useState<boolean>(true);

  const actTypeBlockId = getActTypeActBlockId(id);
  const lateFieldName = value.organization?.guid ? `organization/${value.organization.guid}/act` : '';

  const isShowEventsItem = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_4_1_55_STARTS_FROM,
  );

  const isEnablePrescriptionCheck = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM,
  );

  const reasonsErknm = formRef?.current.getFieldState('reasonsErknm')?.value;

  const isPrescriptionCheck =
    reasonsErknm?.[0].reason?.type?.name === KnmReasonTypeNameEnum.PRESCRIPTION_CHECK &&
    isPrescriptionCheckByOldRules === false;
  const initActValues = initialFormValues.acts?.[index];
  const isActFilled =
    !!initActValues?.numberAct &&
    !!initActValues.creationActDateTime &&
    !!initActValues.holdingDateTime &&
    !!initActValues.document?.attachments?.length &&
    !!initActValues.fioSigner &&
    !!initActValues.titleSigner &&
    !!initActValues.knoInspectors?.length &&
    (!initActValues.isViolationResolved?.value || !!initActValues.isViolationResolvedNote) &&
    (!!initActValues.durationDays || !!initActValues.durationHours) &&
    !!initActValues.acquaintanceType &&
    ((!isShowEventsItem && (isKnmStatusCompleted || isKnmStatusDecisionAppealed)) || !!initActValues.events?.length) &&
    (initActValues.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_II ||
      initActValues.acquaintanceType?.code === AcquaintanceTypeCodesEnum.ACQ_TYPE_IV ||
      (!!initActValues.fioReader && !!initActValues.titleReader));

  const isDisabledByComplete =
    !isNewAct && isKnmStatusCompleted && (knmActType === ActTypesEnum.KNM_ACT_IMPOSSIBLE || isActFilled);

  useEffect(() => {
    if (value.typeAct) {
      setKnmActTypeSelected(value.typeAct.id);
    }
  }, [value]);

  const [isTypeActChanged, setTypeActChanged] = useState(false);

  const handleActTypeChange = useCallback(
    (v: ISelectOption) => {
      if (knmActType !== null) {
        setTypeActChanged(true);
        const values = formRef?.current.getState().values;
        const numberAct = values?.acts?.[index].numberAct;
        const emptyOrganization = values?.acts?.[index].organization;
        const initGuid = values?.acts?.[index].guid;
        const initOrganizations = values?.organizations;
        const typeAct = knmActTypesOptions?.find(option => option.id === v?.value);

        if (!isPaperless) {
          const isNew = formRef?.current.getState().values.acts?.[0].isNew ?? false;

          formRef?.current.change('acts', [
            {
              extractVersion: undefined,
              involvedExperts: undefined,
              involvedWitnesses: undefined,
              acquaintanceLackNoInfoComment: undefined,
              acquaintanceLackType: undefined,
              acquaintanceType: undefined,
              canceledReason: undefined,
              canceledReasonDescription: undefined,
              created: undefined,
              createdBy: undefined,
              creationActDateTime: undefined,
              document: undefined,
              durationDays: undefined,
              durationHours: undefined,
              events: undefined,
              fioAndPositionSinger: undefined,
              fioReader: undefined,
              fioSigner: undefined,
              guid: initGuid,
              holdingDateTime: undefined,
              isNew,
              isViolatedMandatoryRequirements: undefined,
              isViolationResolved: undefined,
              isViolationResolvedNote: undefined,
              knoInspectors: undefined,
              listId: uuidv4(),
              nextWordDayActDateTime: undefined,
              noteInvalidate: undefined,
              numberAct: undefined,
              organization: undefined,
              organizationTemplate: undefined,
              refuserFio: undefined,
              refuserTitle: undefined,
              canceled: false,
              titleReader: undefined,
              titleSigner: undefined,
              typeAct,
              updated: undefined,
              updatedBy: undefined,
              violatedMandatoryRequirements: undefined,
              familiarizationNotifications: undefined,
              remarks: undefined,
              signed: undefined,
              signActDateTime: undefined,
              paperless: isPaperless,
              firstExtractDateTime: null,
              systemSignatureUsed: false,
              systemSignatureTitle: null,
              systemSignatureDateTime: null,
              systemSignatureMnemonic: null,
            },
          ]);
        }

        if (isPaperless && knmActType === ActTypesEnum.KNM_ACT_IMPOSSIBLE) {
          // @ts-ignore
          formRef?.current.change(name, {
            extractVersion: undefined,
            involvedExperts: undefined,
            involvedWitnesses: undefined,
            acquaintanceLackNoInfoComment: undefined,
            acquaintanceLackType: undefined,
            acquaintanceType: undefined,
            canceledReason: undefined,
            canceledReasonDescription: undefined,
            created: undefined,
            createdBy: undefined,
            creationActDateTime: undefined,
            document: undefined,
            durationDays: undefined,
            durationHours: undefined,
            events: undefined,
            fioAndPositionSinger: undefined,
            fioReader: undefined,
            fioSigner: undefined,
            guid: initGuid,
            holdingDateTime: undefined,
            isNew: false,
            isViolatedMandatoryRequirements: undefined,
            isViolationResolved: undefined,
            isViolationResolvedNote: undefined,
            knoInspectors: undefined,
            listId: uuidv4(),
            nextWordDayActDateTime: undefined,
            noteInvalidate: undefined,
            numberAct,
            organization: undefined,
            organizationTemplate: undefined,
            refuserFio: undefined,
            refuserTitle: undefined,
            canceled: false,
            titleReader: undefined,
            titleSigner: undefined,
            typeAct,
            updated: undefined,
            updatedBy: undefined,
            violatedMandatoryRequirements: undefined,
            familiarizationNotifications: undefined,
            remarks: undefined,
            signed: undefined,
            signActDateTime: undefined,
            paperless: isPaperless,
          });
          formRef?.current.change(
            'organizations',
            initOrganizations?.filter(x => x.guid !== emptyOrganization?.guid),
          );
        }
      }

      if (isPaperless) {
        if (kindKnmCode !== KnmKindCodesEnum.RO && v?.id === ActTypesEnum.KNM_ACT) {
          const organization = organizationsTemplatesSelectOptions?.[0];

          // @ts-ignore
          formRef?.current.change(`${name}.organization`, {
            subjectType: organization?.subjectType,
            inn: organization?.inn,
            ogrn: organization?.ogrn,
            organizationName: organization?.organizationName,
            isFiz: organization?.isFiz,
            kpp: organization?.kpp,
            rafpNza: organization?.rafpNza,
            isForeignSubjectAgencyNotRegistredInRf: organization?.isForeignSubjectAgencyNotRegistredInRf,
            country: organization?.country,
            nkoForeignAgentsRegistryNumber: organization?.nkoForeignAgentsRegistryNumber,
            nkoForeignAgentsRegistryInclusionDate: organization?.nkoForeignAgentsRegistryInclusionDate,
            nkoForeignAgentsRegistryExclusionDate: organization?.nkoForeignAgentsRegistryExclusionDate,
            isNko: !!organization?.nkoForeignAgentsRegistryInclusionDate,
            isDocumentOrganization: !!organization?.isDocumentOrganization,
            id: organization?.id,
            locationAddress: organization?.locationAddress,
            locationregion: organization?.locationregion,
            locationnotInFIAS: organization?.locationnotInFIAS,
            locationmanualAddress: organization?.locationmanualAddress,
            locationfiasRegion: organization?.locationfiasRegion,
            locationRegionCodeFromFns: organization?.locationRegionCodeFromFns,
            workAddress: organization?.workAddress,
            factualAddress: organization?.factualAddress,
            snils: organization?.snils,
            document: organization?.document,
            isSonko: organization?.isSonko,
            mspCode: organization?.mspCode,
            isPresentInItRegistry: organization?.isPresentInItRegistry,
            itAccreditationResponse: organization?.itAccreditationResponse,
            smevItAccreditationRequestStatus: organization?.smevItAccreditationRequestStatus,
            checkSubjectResult: organization?.checkSubjectResult,
            listId: organization?.id,
            ervkId: organization?.ervkId,
          });
        }
      }

      setKnmActTypeSelected(v?.value);
    },
    [
      formRef,
      knmActType,
      knmActTypesOptions,
      name,
      organizationsTemplatesSelectOptions,
      isPaperless,
      index,
      isEnablePrescriptionCheck,
      isPrescriptionCheck,
    ],
  );

  const options = knmActTypesOptions?.filter(option => {
    // 1 - Акт КНМ доступен для всех статусов, кроме "Есть замечания", "Ожидает проведения", "Исключена", "Исключение обжаловано"
    // 2 - Акт о невозможности проведения КНМ, доступен для всех статусов, кроме "Завершено"
    // disableActAddingByImpossibleStatus - true, если статус не из списка выше
    return option.id === 1 ? disableActAddingByImpossibleStatus : !isKnmStatusCompleted;
  });

  const [actTypeOptions, setActTypeOptions] = useState<IKnmActTypeSelectOption[] | undefined>(
    options ? [...options] : undefined,
  );

  useEffect(() => {
    // @ts-ignore
    if (formRef?.current.getFieldState('acts')?.value?.filter(x => x.typeAct?.id === 2)?.length > 0) {
      let typeOptions = options;

      if (!isPaperless) {
        typeOptions = knmActTypesOptions?.filter(x => {
          return x.id === 1 && disableActAddingByImpossibleStatus;
        });
      }

      setActTypeOptions(typeOptions ? [...typeOptions] : undefined);
    } else {
      setActTypeOptions(
        options ? [...options.filter(x => x.id === 2 || (inspectorsErknm && inspectorsErknm.length !== 0))] : undefined,
      );
    }
  }, [formRef?.current.getFieldState('acts')]);

  const canceledActsInJudgments = formRef?.current
    .getFieldState('judgments')
    ?.value?.filter(x => x.judgmentSubjectData)
    ?.flatMap(x => {
      return x.judgmentSubjectData
        ?.flatMap(a => {
          return a.cancellationActsAndDecisions?.map(b => {
            return b.actGuid;
          });
        })
        .filter(a => a?.length);
    })
    .filter(x => x?.length);

  const canceledActsInCancelledJudgments = formRef?.current
    .getFieldState('judgments')
    ?.value?.filter(x => x.canceledJudgments)
    ?.flatMap(x => {
      return x.canceledJudgments
        ?.flatMap(j => {
          return j.judgmentSubjectData
            ?.flatMap(a => {
              return a.cancellationActsAndDecisions
                ?.filter(b => b.actGuid && b.newCancellationInformation?.name === 'Отмена решения')
                .map(b => {
                  return b.actGuid;
                });
            })
            .filter(a => a?.length);
        })
        .filter(j => j?.length);
    })
    .filter(x => x?.length);

  useEffect(() => {
    canceledActsInJudgments?.forEach(x => {
      if (x === value.guid) {
        setIsActCancelled(true);
      }
    });
    canceledActsInCancelledJudgments?.forEach(x => {
      if (x === value.guid) {
        if (
          canceledActsInJudgments &&
          canceledActsInJudgments.filter(a => a === value.guid).length >
            canceledActsInCancelledJudgments?.filter(a => a === value.guid).length
        ) {
          setIsActCancelled(true);
        } else {
          setIsActCancelled(false);
        }
      }
    });
  }, [canceledActsInJudgments, canceledActsInCancelledJudgments, formRef?.current.getFieldState('judgments')]);

  const hasErrors = checkHasErrorInCollapseBlock(formRef, name);

  return (
    <KnmCollapse
      error={hasErrors && isKnmCollapseOpened}
      theme="fields"
      title={COLLAPSE_TITLE_BASE}
      id={id}
      subtitle={value.numberAct}
      opened={(!isClosedByManyActs || isNewAct) && (isNewAct || !isTypeActChanged) && !value?.fileInvalidate}
      onClose={isNewAct && !isDisabledByDirty ? onRemove : undefined}
      tooltipText="Судебным решением осуществлена отмена (изменение) акта"
      showWarningTooltip={isActCancelled}
      showLeftWarningMarker={isActCancelled}
      headerPostfix={<ErknmActHistory act={value} isPaperless={isPaperless} />}
      changeOpenedCallback={setIsKnmCollapseOpened}
    >
      <>
        <Row>
          <FieldBlock
            label={getTitleFieldWithRedStar({
              label: `Вид акта`,
              field: `${name}.typeAct`,
              isPm,
              isDecision,
              isKnm: !isPm && !isDecision,
            })}
            id={actTypeBlockId}
            tooltip={<KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/typeAct/name`} fieldId={actTypeBlockId} />}
          >
            <SelectInputField
              name={`${name}.typeAct`}
              options={actTypeOptions}
              size="medium"
              disabled={
                isWatchOnly ||
                isDisabledByComplete ||
                value.signed ||
                !!value.fileInvalidate ||
                isDisabledByDirty ||
                (isPaperless && !!value.document)
              }
              onChange={handleActTypeChange}
              isClearable={isPaperless}
            />
          </FieldBlock>
        </Row>

        {isPaperless ? (
          <ErknmPaperlessActContentKnm
            id={id}
            index={index}
            isWatchOnly={isWatchOnly || !!value.fileInvalidate}
            isDisabledByComplete={isDisabledByComplete}
            isDisabledByDirty={isDisabledByDirty}
            name={name}
            value={value}
            acts={acts}
            inspectorsErknm={inspectorsErknm}
            kindKnmCode={kindKnmCode}
            organizationsTemplatesSelectOptions={organizationsTemplatesSelectOptions}
            expertsErknm={expertsErknm}
            addRequirementsNpa={addRequirementsNpa}
            addViolatedMandatory={addViolatedMandatory}
            formRef={formRef}
            // isKnmKindRO={isKnmKindRO}
            isEnablePrescriptionCheck={isEnablePrescriptionCheck}
            isPrescriptionCheck={isPrescriptionCheck}
          />
        ) : (
          <>
            {knmActType === ActTypesEnum.KNM_ACT_IMPOSSIBLE && (
              <ErknmActsItemContentImpossible
                id={id}
                index={index}
                isDisabledByComplete={isDisabledByComplete}
                isWatchOnly={isWatchOnly}
                name={name}
                value={value}
                isPaperless={isPaperless}
                isPm={isPm}
                isDecision={isDecision}
                lateFieldName={lateFieldName}
              />
            )}

            {knmActType === ActTypesEnum.KNM_ACT && (
              <ErknmActsItemContentKnm
                id={id}
                index={index}
                isWatchOnly={isWatchOnly}
                isDisabledByComplete={isDisabledByComplete}
                name={name}
                value={value}
                addRequirementsNpa={addRequirementsNpa}
                addViolatedMandatory={addViolatedMandatory}
                inspectorsErknm={inspectorsErknm}
                kindKnmCode={kindKnmCode}
                organizationsTemplatesSelectOptions={organizationsTemplatesSelectOptions}
                participantPositionsSelectOptions={participantPositionsSelectOptions}
                lateFieldName={lateFieldName}
                events={events}
              />
            )}
          </>
        )}
      </>
    </KnmCollapse>
  );
};

const mapStateToProps = (state: IRootState): IErknmActsItemStoreProps => ({
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
  initialFormValues: getKnmErknmInitialFormValues(state),
  isKnmStatusCompleted: getKnmIsErknmStatusTypeCompleted(state),
  isKnmStatusDecisionAppealed: getKnmIsErknmStatusDecisionAppealed(state),
  knmActTypesOptions: getCatalogsKnmActTypesSelectOptions(state),
  settings: getAdminFetchSettings(state),
  isPrescriptionCheckByOldRules: getKnmErknmIsPrescriptionOldRules(state),
});

export const ErknmActsItem = connect(mapStateToProps)(ErknmActsItemWithoutStore);
